import { render } from "./BlockFooter.vue?vue&type=template&id=67eac7b4&scoped=true"
import script from "./BlockFooter.vue?vue&type=script&lang=js"
export * from "./BlockFooter.vue?vue&type=script&lang=js"

import "./BlockFooter.vue?vue&type=style&index=0&id=67eac7b4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67eac7b4"]])

export default __exports__